import {connect} from 'react-redux';

import {buildVisualRecipientForEmail} from '../../../../../../../../src/helpers/models/recipientParsers';
import {makeMapDispatchToProps} from '../../../../../../../../src/helpers/reselectHelpers';
import {RecipientRolesEnum} from '../../../../../../../../src/models/api/recipientModel';
import {composeMessageAction} from '../../../../../../../../src/store/data/messages/draftMessagesActions';
import {AccountInfoBoxes} from './accountInfoBoxes';

/*
 * Constants.
 */

const supportEmailRecipient = buildVisualRecipientForEmail(RecipientRolesEnum.TO, 'support@frontapp.com');
const supportEmailSubject = 'Front Accounts feedback';

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onSendFeedbackClick: () =>
    composeMessageAction({
      recipients: [supportEmailRecipient],
      shouldForcePopout: true,
      subject: supportEmailSubject,
    }),
}));

export const AccountInfoBoxesContainer = connect(null, mapDispatchToProps)(AccountInfoBoxes);
